// neo_cogym — 콘텐츠/가이드 서비스 (W5)
// 코딩스쿨 IPC(getGuideFiles/checkGuideExists)를 웹으로 치환:
// 가이드 파일 목록을 콘텐츠 API(R2 매니페스트)에서 가져오고, page_N/NNN 패턴으로 정렬.
// (T1 분석: 메인 프로세스가 fs로 읽던 resources/guides 를 R2+CDN 으로 이전)

import { API_BASE } from "../api/client";

/** 가이드 파일에서 페이지 번호 추출(코딩스쿨 IPCinit.js 정렬 로직 포팅) */
export function pageNumber(filename: string): number {
  let m = filename.match(/page_(\d+)/i);
  if (m) return parseInt(m[1], 10);
  m = filename.match(/^(\d+)\./);
  if (m) return parseInt(m[1], 10);
  m = filename.match(/(\d+)/);
  return m ? parseInt(m[1], 10) : 0;
}

const GUIDE_EXT = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".mp4", ".webm", ".ogg", ".txt"];

export function isGuideFile(name: string): boolean {
  const dot = name.lastIndexOf(".");
  return dot >= 0 && GUIDE_EXT.includes(name.slice(dot).toLowerCase());
}

/** 가이드 파일 목록을 페이지 순으로 정렬(코딩스쿨과 동일 규칙) */
export function sortGuideFiles(files: string[]): string[] {
  return files.filter(isGuideFile).sort((a, b) => pageNumber(a) - pageNumber(b));
}

export interface GuideManifest {
  contentPath: string;
  tabType?: string;
  files: string[];
}

/**
 * 가이드 매니페스트 조회. 콘텐츠 API(/api/content/guides)가 R2의 파일 목록을 반환한다고 가정.
 * (서버가 R2 prefix 리스팅 → 파일명 배열 반환)
 */
export async function fetchGuideFiles(
  contentPath: string,
  tabType?: string,
  opts: { endpoint?: string; getAuthToken?: () => string | null } = {},
): Promise<string[]> {
  const base = opts.endpoint ?? `${API_BASE}/api/content/guides`;
  const url = `${base}?path=${encodeURIComponent(contentPath)}${tabType ? `&tab=${encodeURIComponent(tabType)}` : ""}`;
  const token = opts.getAuthToken?.();
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) return [];
  const data = (await res.json()) as { files?: string[] };
  return sortGuideFiles(data.files ?? []);
}

/** 가이드 파일의 실제 자산 URL(R2/CDN, Worker 오리진 기준) */
export function guideAssetUrl(contentPath: string, file: string, cdnBase = `${API_BASE}/content`): string {
  return `${cdnBase}/guides/${contentPath}/${file}`;
}
